(function (global) {
  'use strict';

  const CONTRACT_VERSION = 'nf-city-commerce/3.0.0';
  const MODULE_MANIFEST_SCHEMA = 'nf-city-modules/1.0.0';
  const priceContract = global.NF_CITY_PRICE_CONTRACT;
  if (priceContract?.contract_version !== 'nf-city-pricing/2026-09-22') {
    throw new Error('44 × 44-priskontrakten mangler eller har forkert version');
  }
  const PRICE_CONTRACT_VERSION = priceContract.contract_version;
  const EXPECTED_PRICES_MINOR = Object.freeze({ ...priceContract.sizes['44'].totals_minor });
  const MODULE_KEYS = Object.freeze(['a1', 'a2', 'b1', 'b2']);

  const normalize = value => String(value || '').normalize('NFKC').trim().toLowerCase();
  function selectionKey(snapshot) {
    const style = normalize(snapshot?.style);
    const frame = snapshot?.frame === 'med' ? 'med' : 'uden';
    const finish = frame === 'uden'
      ? 'ingen'
      : snapshot?.frameConfig?.surface === 'proMaterial' ? 'pro' : 'klassisk';
    const key = `${style}|${frame}|${finish}`;
    if (!Object.hasOwn(EXPECTED_PRICES_MINOR, key)) throw new Error('44 × 44-valget matcher ikke produktkataloget');
    return key;
  }

  function variantKey(variant) {
    const values = [variant?.option1, variant?.option2, variant?.option3]
      .filter(value => value !== undefined && value !== null && value !== '')
      .map(normalize);
    if (!values.length) values.push(...normalize(variant?.title).split('/').map(value => value.trim()));
    const joined = values.join('|');
    const style = joined.includes('farve') ? 'farve' : joined.includes('hvid') ? 'hvid' : '';
    const frame = joined.includes('uden ramme') || joined.includes('|uden|') ? 'uden'
      : joined.includes('med ramme') || joined.includes('|med|') ? 'med' : '';
    const finish = frame === 'uden' ? 'ingen' : joined.includes('pro') ? 'pro'
      : (joined.includes('klassisk') ? 'klassisk' : '');
    return style && frame && finish ? `${style}|${frame}|${finish}` : '';
  }

  function resolveProduct(product) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const grouped = new Map();
    for (const variant of variants) {
      const key = variantKey(variant);
      if (!key) continue;
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key).push(variant);
    }
    const resolved = {};
    const errors = [];
    for (const [key, expected] of Object.entries(EXPECTED_PRICES_MINOR)) {
      const candidates = grouped.get(key) || [];
      if (candidates.length !== 1) {
        errors.push(`${key}: ${candidates.length ? 'dubleret variant' : 'variant mangler'}`);
        continue;
      }
      const variant = candidates[0];
      const priceMinor = Number(variant.price);
      if (!variant.id || variant.available === false || priceMinor !== expected) {
        errors.push(`${key}: ID, tilgængelighed eller pris matcher ikke`);
        continue;
      }
      resolved[key] = Object.freeze({ id: variant.id, priceMinor, title: variant.title || key });
    }
    return Object.freeze({ ok: errors.length === 0, resolved: Object.freeze(resolved), errors: Object.freeze(errors) });
  }

  function selectedVariant(resolution, snapshot) {
    if (!resolution?.ok) throw new Error('44 × 44-produktet er ikke klart');
    const key = selectionKey(snapshot);
    const variant = resolution.resolved[key];
    if (!variant || variant.priceMinor !== EXPECTED_PRICES_MINOR[key]) throw new Error('44 × 44-prisen matcher ikke valget');
    return { ...variant, key };
  }

  function moduleProperties(refs) {
    if (!Array.isArray(refs) || refs.length !== 4) throw new Error('44 × 44 kræver præcis fire modulreferencer');
    const properties = { '_nf_module_manifest_schema': MODULE_MANIFEST_SCHEMA };
    refs.forEach((ref, index) => {
      const id = String(ref?.design_id || '');
      const hash = String(ref?.design_record_sha256 || '');
      if (!/^NF-CITY-\d{8}-\d{4}$/.test(id) || !/^sha256:[0-9a-f]{64}$/.test(hash)) {
        throw new Error(`Modul ${MODULE_KEYS[index].toUpperCase()} mangler verificerbar identitet`);
      }
      properties[`_nf_module_${MODULE_KEYS[index]}`] = `${id}|${hash}`;
    });
    return properties;
  }

  global.NF_CITY_SINGLE_LINE = Object.freeze({
    CONTRACT_VERSION, PRICE_CONTRACT_VERSION, MODULE_MANIFEST_SCHEMA, EXPECTED_PRICES_MINOR, MODULE_KEYS,
    selectionKey, resolveProduct, selectedVariant, moduleProperties
  });
})(globalThis);
